import { Icon, IconButton, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const SearchIconButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Tooltip arrow title={t('f-search')}>
      <IconButton color="primary" size="medium" onClick={onClick}>
        <Icon>{'search'}</Icon>
      </IconButton>
    </Tooltip>
  );
};

export default SearchIconButton;
